import React from "react";
import { Button } from "@mui/material";

const formatPreviewLine = (line) => {
  const [label, ...rest] = String(line || "").split(":");
  if (!rest.length) {
    return line;
  }

  const normalizedLabel = label.trim().toLowerCase();
  const boldLabels = ["caller id", "duration", "received"];

  if (!boldLabels.includes(normalizedLabel)) {
    return line;
  }

  return (
    <span>
      <strong>{label}:</strong>
      {rest.join(":")}
    </span>
  );
};

const SampleEmailContent = ({
  leftEmail,
  rightEmail,
  setLeftEmail,
  setRightEmail,
  onTestParsing,
  isParsing = false,
  parseError = "",
}) => {
  const hasParsedOutput = Boolean(String(rightEmail || "").trim());

  return (
    <div className="bg-[#f3f4f6] border border-gray-300 rounded-xl p-5 w-full h-full">
      <>
        <h2 className="text-lg font-bold text-[#0f2b46] mb-4">
          Sample Email Content
        </h2>

        {/* Two Side-by-Side Textareas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          {/* Left Box */}
          <div>
            {/* <p className="text-xs font-semibold text-content mb-1">Email Body (Input)</p> */}
            <textarea
              value={leftEmail}
              onChange={(e) => setLeftEmail(e.target.value)}
              placeholder={`From: PBX System
Subject: New Voicemail

You have received a new voicemail message.`}
              className="w-full h-full bg-white border border-gray-400 rounded-md p-3 text-xs font-mono resize-none focus:outline-none focus:ring-1 focus:ring-blue-400 placeholder:text-muted"
              rows={5}
            />
          </div>

          {/* Right Box */}
          <div>
            {/* <p className="text-xs font-semibold text-content mb-1">Parsed Output</p> */}
            <div
              className={`w-full bg-white border border-gray-400 rounded-md p-3 text-xs font-mono min-h-[120px] whitespace-pre-wrap ${
                hasParsedOutput ? "text-primary" : "text-muted"
              }`}
            >
              {(rightEmail || `Caller ID: TOLL FREE CALL (555 123-4567)
Duration: 45 seconds
Received: 2024-01-15 10:30 AM
`)
                .split("\n")
                .map((line, index) => (
                  <div key={`${index}-${line}`}>{formatPreviewLine(line)}</div>
                ))}
            </div>
          </div>
        </div>
      </>

      <>
      {/* Description Text */}
      <p className="text-xs text-gray-600 mb-2">
        Paste an actual email from your PBX system to test the parser
      </p>

      {/* Button */}
      <Button
        variant="contained"
        fullWidth
        onClick={onTestParsing}
        disabled={isParsing || !String(leftEmail || "").trim()}
        sx={{
          backgroundColor: "#001f3f",
          color: "white",
          fontSize: "12px",
          fontWeight: 700,
          borderRadius: "6px",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          padding: "10px 16px",
          "&:hover": {
            backgroundColor: "#003366",
          },
        }}
      >
        {isParsing ? "TESTING..." : "TEST PARSING"}
      </Button>

      {parseError ? (
        <p className="text-xs text-red-600 mt-2">{parseError}</p>
      ) : null}

      {/* Bottom Text */}
      <p className="text-xs text-gray-500 mt-2">
        Configure PBX system integration settings
      </p>
      </>
    </div>
  );
};

export default SampleEmailContent;
